import moment, { Moment } from "moment";

interface MonthSelectProps {
  value: Moment;
  onChange: (date: Moment, monthIndex: number) => void;
}

const MonthSelect = ({ value, onChange }: MonthSelectProps) => (
  <select
    value={value.month()}
    onChange={e => {
      onChange(value, parseInt(e.target.value));
    }}
  >
    {moment.months().map((label, value) => (
      <option key={label} value={value}>
        {label}
      </option>
    ))}
  </select>
);

export default MonthSelect;
